import Dialog from 'material-ui/Dialog';
import RadioButton from 'material-ui/RadioButton';
import RaisedButton from 'material-ui/RaisedButton';
import RadioButtonChecked from 'material-ui/svg-icons/toggle/radio-button-checked';
import RadioButtonUnchecked from 'material-ui/svg-icons/toggle/radio-button-unchecked';
import * as React from 'react';
import {connect} from 'react-redux';
import {actions} from 'react-redux-form';
import {withRouter} from 'react-router';
import {TextColor} from '../../constants/generals';
import {IHistory} from '../../interfaces';
import {ModuleModel} from '../../model/ModuleModel';
import {getModuleDetails, submitTest} from '../../services/moduleService';
import {dispatch, getCurrentUserUUID, userName, userUniqueID} from '../../utils/generalUtils';
import {BasePage} from '../reusableComponents/BasePage';
import {CustomFlatButton} from '../reusableComponents/CutomFlatButton';
import {Form} from '../reusableComponents/FormComponents/Form';
import {Loader} from '../reusableComponents/Loader/Loader';
import './modules.scss';
import {showAlert} from '../../actions/miscellaneousActions';
import * as _ from 'lodash';

export interface IMCQFormInstance {
    UserId: string;
    ModuleId: string;
    Answers: {
        QueNum: number;
        Answer: string;
    }[];
}

export interface IMCQPageProps {
    moduleName: string;
    moduleInstance: ModuleModel;
    moduleId: string;
    mcqFormInstance: IMCQFormInstance;
    userUID: string;
    history: IHistory;
    userName: string;
}

export interface IMCQPageState {
    storedIndexes: number[];
    isFullScreen: boolean;
    acknowledgementDone: boolean;
}

export class MCQPageImpl extends React.PureComponent<IMCQPageProps, IMCQPageState> {
    constructor(props: IMCQPageProps) {
        super(props);
        this.state = {storedIndexes: [], acknowledgementDone: true, isFullScreen: false};
    }

    public onAcknowledged = () => {
        const isInstruction = this.props.moduleInstance && this.props.moduleInstance.props.ModuleType === 'Instruction Module';
        if (isInstruction || (this.props.moduleInstance && this.props.moduleInstance.props.Questions.length > 0)) {
            this.setState({isFullScreen: true, acknowledgementDone: false});
        } else {
            this.setState({acknowledgementDone: false});
            this.handleMCQSubmit({UserId: getCurrentUserUUID(), ModuleId: this.props.moduleInstance.props.ModuleID});
        }
    }

    public renderAcknowledgement = () => {
        const actionsImpl = [
            <CustomFlatButton
                label="No"
                color={'black'}
                primary={true}
                onClick={() => this.props.history.push(`/training/${this.props.moduleId}`)}
            />,
            <CustomFlatButton
                label="Yes"
                color={'black'}
                primary={true}
                onClick={this.onAcknowledged}
            />
        ];
        return <Dialog
            title="Acknowledgement"
            actions={actionsImpl}
            modal={true}
            open={this.state.acknowledgementDone}
        >
            This is to acknowledge that you have read all the documents attached to this module and went through
            the links and read that all.
            Click on Yes to accept the acknowledgement or No to go back and read again.
        </Dialog>;
    }

    public promise = async () => {
        if (!this.props.moduleInstance) {
            await getModuleDetails(this.props.moduleId);
        }
    }

    public handleMCQSubmit = async (values) => {
        this.setState({
            isFullScreen: false
        });

        const isInstruction = this.props.moduleInstance.props.ModuleType === 'Instruction Module';

        if (!isInstruction && (!values.Answers || values.Answers.length !== this.props.moduleInstance.props.Questions.length)) {
            showAlert({
                    title: 'Oops..!!',
                    text: 'Fill all the answers.',
                    type: 'error',
                    closeOnConfirm: true,
                    confirmCallback: () => {
                        this.setState({
                            isFullScreen: true
                        });
                    }
                },
                'submission');
            return;
        }

        return await submitTest(values, this.props.history,
            this.props.userName, this.props.moduleName.replace(/#|-/g, '/'), false, isInstruction);
    }

    continueLaterSubmit = async () => {
        const answersList = this.props.mcqFormInstance.Answers;
        const questionsList = this.props.moduleInstance.props.Questions;
        const answersToSubmit = [];
        questionsList.forEach((question) => {
            const filledAnswer = _.find(answersList, {QueNum: question.questionNum});
            answersToSubmit.push({
                QueNum: question.questionNum,
                Answer: filledAnswer ? filledAnswer.Answer : null
            });
        });
        const valuesToSubmit = {
            UserId: this.props.userUID,
            ModuleId: this.props.moduleId,
            Answers: answersToSubmit
        };
        return await submitTest(valuesToSubmit, this.props.history,
            this.props.userName, this.props.moduleName.replace(/#|-/g, '/'), true);
    }

    public handleAnswerSelect = (value: boolean, questionNum: number) => {
        dispatch(actions.filter('forms.mcqForm.Answers', (ansValue) => {
            return ansValue.QueNum !== questionNum;
        }));
        dispatch(actions.push('forms.mcqForm.Answers', {
            QueNum: questionNum, Answer: value
        }));
    }

    public loadDefaultValues = () => {
        const answers = [];
        if (this.props.moduleInstance && this.props.moduleInstance.props.Questions && this.props.moduleInstance.props.Questions.length) {
            this.props.moduleInstance.props.Questions.forEach((question) => {
                answers.push({
                    Answer: question.answer,
                    QueNum: question.questionNum
                });
            });
        }
        dispatch(actions.change('forms.mcqForm.UserId', this.props.userUID));
        dispatch(actions.change('forms.mcqForm.ModuleId', this.props.moduleId));
        dispatch(actions.change('forms.mcqForm.Answers', answers));
    }

    public renderForm = () => {
        const {moduleInstance, mcqFormInstance: {Answers}} = this.props;
        if (!moduleInstance) {
            return <Loader type="async"/>;
        }
        const {props: {Questions, ModuleType, Instructions}} = this.props.moduleInstance;
        const isInstruction = ModuleType === 'Instruction Module';
        
        return <Form
            loadDefaultValues={this.loadDefaultValues}
            model="forms.mcqForm"
            className="mcq-container"
            onSubmit={this.handleMCQSubmit}
        >
            <div className="mcq-page">
                {isInstruction && (
                    <div className="container" style={{padding: '20px'}}>
                        {(() => {
                            try {
                                const parsed = JSON.parse(Instructions || '[]');
                                if (Array.isArray(parsed) && parsed.length > 0) {
                                    return (
                                        <ol style={{paddingLeft: '20px', fontSize: '16px'}}>
                                            {parsed.map((inst, idx) => (
                                                <li key={idx} style={{marginBottom: '10px'}}>{inst}</li>
                                            ))}
                                        </ol>
                                    );
                                }
                            } catch (e) {}
                            return <div dangerouslySetInnerHTML={{__html: Instructions || ''}}></div>;
                        })()}
                    </div>
                )}
                {!isInstruction && Questions.map((quesData, index) => {
                    const isChecked =
                        (Answers || []).filter((ansData) => {
                            return ansData.QueNum === quesData.questionNum ?
                                `${ansData.Answer}` : '';
                        });
                    if (quesData.answer) {
                        isChecked.push({
                            Answer: quesData.answer,
                            QueNum: quesData.questionNum
                        });
                    }
                    return <div key={index} className="container">
                        <span className="ques-num">{quesData.questionNum}</span>
                        <div className="ques-container">
                            {quesData.question}
                        </div>
                        <div className="answer-container">
                            {
                                quesData.Choices.map((choice, i) => {
                                    return <RadioButton className="radio-button"
                                                        key={'rb' + quesData.questionNum + i.toString()}
                                                        onCheck={() => this.handleAnswerSelect(choice, quesData.questionNum)}
                                                        value={quesData.answer}
                                                        checked={isChecked.length > 0 && isChecked[0].Answer === choice}
                                                        label={choice}
                                                        checkedIcon={<RadioButtonChecked style={{fill: '#8bd05d'}}/>}
                                                        uncheckedIcon={<RadioButtonUnchecked style={{fill: '#7B7D7F'}}/>}
                                    />;
                                })
                            }
                        </div>
                    </div>;
                })}
            </div>
            <div className="form-footer">
                <RaisedButton
                    type="submit"
                    style={{
                        backgroundColor: TextColor
                    }}
                    className="submit-button"
                    label={isInstruction ? "Mark as Complete" : "Submit"}
                    primary={true}
                />
                {!isInstruction && (
                    <RaisedButton
                        type="button"
                        style={{
                            backgroundColor: TextColor
                        }}
                        onClick={() => {
                            this.continueLaterSubmit();
                        }}
                        className="submit-button"
                        label="Continue Later"
                        primary={true}
                    />
                )}
            </div>
            {/* <FormFooter /> */}
        </Form>;
    }

    public render() {
        const moduleType = this.props.moduleInstance ? this.props.moduleInstance.props.ModuleType : 'MCQ';
        const pageTitle = moduleType === 'Instruction Module' ? 'Instructions' : 'MCQ';
        
        return <BasePage title={pageTitle} icon="question-circle">
            {this.renderAcknowledgement()}
            {this.renderForm()}
            {/* <Fullscreen
                enabled={this.state.isFullScreen}
            >
                {this.state.isFullScreen ?
                    < Async
                        identifier="MCQ"
                        promise={this.promise}
                        loader={< Loader type="async"/>}
                        content={this.renderForm()}
                        error={<ErrorPage/>}
                    />
                    : ''}
            </Fullscreen>*/}
        </BasePage>;
    }
}

export function mapStateToProps(state, ownProps) {
    const moduleInstance = ModuleModel.get(ownProps.match.params.id);
    const moduleName = ownProps.match.params.moduleName;
    const mcqFormInstance = state.forms.mcqForm;
    return {
        moduleId: ownProps.match.params.id,
        moduleInstance, mcqFormInstance,
        userUID: userUniqueID(state),
        userName: userName(state),
        moduleName
    };
}

export const MCQPage = withRouter(connect<{}, {}, IMCQPageProps>(mapStateToProps)(MCQPageImpl) as any);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/Modules/MCQPage.tsx